import React from 'react';
import { _t } from 'utils';
import { getEstimatedPriceForDatabase } from 'utils/billing';
import { formatCurrency } from 'utils/currency';
import IconPopup from '../help-icon-popup';

export default ({
  model, databaseType, title, showInfo = true, freeOfCharge,
}) => {
  const { hourlyRate = 0, monthlyRate = 0 } = freeOfCharge ? {} : getEstimatedPriceForDatabase({
    ...model,
    databaseType,
  });

  return (
    <div className="flex flex-column flex-align-end m-b-10">
      <div className="m-t-5 m-b-5">
        {title || _t('COMMON.LABELS.ESTIMATED_COST')}
        { showInfo && <IconPopup content={_t('BILLING.INFO_TEXTS.PRICE_ESTIMATION')} /> }
      </div>
      <table>
        <tbody>
          <tr className="form-field-sub-title">
            <td>{_t('COMMON.LABELS.PER_HOUR')}</td>
            <td className="text-right">{`${formatCurrency(hourlyRate)}`}</td>
          </tr>
          <tr className="form-field-sub-title">
            <td>{_t('COMMON.LABELS.PER_MONTH')}</td>
            <td className="text-right">{`${formatCurrency(monthlyRate)}`}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
